import { NotificationData, notifications } from '@mantine/notifications';
import { i18n } from 'next-i18next';

const getTitle = (type: 'error' | 'warning' | 'success') => {
  return i18n?.t(`notification.${type}`, { ns: 'utils' }) ?? type;
};

type NotificationProps = Omit<NotificationData, 'message' | 'title' | 'color'>;

const showNotification = (
  type: 'error' | 'warning' | 'success',
  message: string,
  title: string,
  options?: NotificationProps
) => {
  const color = type === 'error' ? 'red' : type === 'warning' ? 'yellow' : 'green';

  notifications.show({
    color,
    title,
    message,
    ...options
  });
};

export const showErrorNotification = (message: string, title = getTitle('error'), options?: NotificationProps) => {
  return showNotification('error', message, title, options);
};

export const showWarningNotification = (message: string, title = getTitle('warning'), options?: NotificationProps) => {
  return showNotification('warning', message, title, options);
};

export const showSuccessNotification = (message: string, title = getTitle('success'), options?: NotificationProps) => {
  return showNotification('success', message, title, options);
};

export const hideNotification = (id: string) => {
  notifications.hide(id);
};
